/** Dispatched on `window`; Navigation in App.jsx opens AuthModal when received. */
export const OPEN_AUTH_MODAL_EVENT = 'propdna:open-auth-modal'

/**
 * @param {'signup' | 'signin'} mode
 */
export function requestAuthModal(mode = 'signup') {
  if (typeof window === 'undefined') return
  const m = mode === 'signin' ? 'signin' : 'signup'
  window.dispatchEvent(new CustomEvent(OPEN_AUTH_MODAL_EVENT, { detail: { mode: m } }))
}
